import SearchPrimary2020 from '@svg/survey/where/search_primary_20_20.svg';
import CloseCircleGray1818 from '@svg/survey/where/close_circle_gray_18_18.svg';
import { useEffect } from 'react';
import './trip-search-bar.css';

interface TripSearchBarProps {
  searchValue: string;
  onChangeSearchValue: (value: string) => void;
  onClickSearch: (value: string) => void;
  onClearSearch: () => void;
  onSearchInteraction?: () => void;
}

export default function TripSearchBar({
  searchValue,
  onChangeSearchValue,
  onClickSearch,
  onClearSearch,
  onSearchInteraction,
}: TripSearchBarProps) {
  useEffect(() => {
    if (searchValue === '') {
      onClearSearch();
    }
  }, [searchValue]);

  const handleClear = () => {
    onChangeSearchValue('');
    onClearSearch();
    onSearchInteraction?.();
  };

  return (
    <div className='absolute z-10 w-full px-20pxr top-16pxr h-44pxr'>
      <div className='relative w-full'>
        <input
          id='search-value-input'
          type='text'
          value={searchValue}
          onFocus={onSearchInteraction}
          onChange={(e) => onChangeSearchValue(e.target.value)}
          className='flex items-center bg-white ring-1 ring-gray-300 px-46pxr rounded-6pxr h-44pxr py-10pxr body-14-regular placeholder:text-gray-500 text-gray-900 transition-all focus:ring-point-500 shadow-clear'
          placeholder='장소 이름, 유형 검색'
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              onClickSearch(searchValue);
            }
          }}
        />
        <span className='absolute w-24pxr h-24pxr left-14pxr top-10pxr p-2pxr'>
          <SearchPrimary2020 className='flex-none' />
        </span>
        <button
          id='search-value-button'
          onClick={() => onClickSearch(searchValue)}
          className='absolute w-0 h-44pxr right-0 top-0 flex items-center justify-center bg-new-point-500 rounded-8pxr shadow-clear'
          aria-label='Search'
        >
          <span className='text-white body-14-md opacity-0'>검색</span>
        </button>
        {searchValue !== '' && (
          <button className='absolute top-10pxr right-88pxr p-3pxr' onClick={handleClear} aria-label='Clear search'>
            <CloseCircleGray1818 className='flex-none' />
          </button>
        )}
      </div>
    </div>
  );
}
